//Library
import React, { Component } from 'react';
//redux
import { connect } from 'react-redux';
import { getExpertInfo } from '../../action/anueInfoAction';
class HouseView extends Component {


    componentWillMount() {
        if (this.props.expertInfo.length === 0) {
          this.props.getExpertInfo();
        }
      }

    render() {
        return <div style={{ overflowX: 'hidden' }}>
            <div className="secContent bg_s secNews">
                <section id="newsPost">
                    <div className="anueContainer">
                        <div className="titleBlock">
                            <h2 data-aos="flip-up">『好日子』專家觀點</h2>
                            <div className="hr"></div>
                        </div>
                    </div>
                </section>
                <div className="newsContainer">
                    <div className="newsWarpper">
                        {
                            this.props.expertInfo.length !== 0 ?
                                this.props.expertInfo.map(({ permalink, title, excerpt, imgUrl }, index) => {
                                    return <div data-aos={index % 2 === 0 ? "fade-up" : "fade-down"} key={index}>
                                        <div className="gap">
                                            <div className="newsPost">
                                                <div className="img" style={{ backgroundImage: 'url(' + imgUrl + ')' }}></div>
                                                <a href={permalink} target="_blank" rel="noopener noreferrer" className="ellipsis" style={{ fontSize: "18px", fontWeight: "500", lineHeight: "1.5", marginTop: "15px", marginBottom: "11px", height: "2.5em", display: "block" }}>{title}</a>
                                                <p style={{ overflow: "hidden" }}>{excerpt}</p>
                                            </div>
                                        </div>
                                    </div>
                                }) : ""
                        }
                    </div>
                </div>
            </div>
        </div>;
    }
}
function mapStateToProps(state) {
    return {
        expertInfo: state.anueInfoState.expertInfo,
    };
}

export default connect(mapStateToProps, { getExpertInfo })(HouseView);